"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const x = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-x` : '') + (description ? ` desc-x` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-x"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-x"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.873.972a.938.938 0 0 0-1.244.073L9 7.673 2.37 1.045 2.289.972a.941.941 0 0 0-1.243.073l-.073.082a.938.938 0 0 0 .073 1.244l6.63 6.628-6.63 6.63-.073.083a.941.941 0 0 0 .073 1.243l.082.073a.938.938 0 0 0 1.244-.073L9 10.325l6.63 6.63.082.073c.384.293.91.26 1.243-.073l.073-.082a.938.938 0 0 0-.073-1.244L10.325 9l6.63-6.628.073-.083a.941.941 0 0 0-.073-1.243l-.082-.073Z",
    fill: "inherit"
  }));
};
var _default = exports.default = x;